import getHrefWithHostname from "./getHrefWithHostname";

const formatExternalLink = (closeAppLink) => {
  return closeAppLink?.href
    ? getHrefWithHostname(closeAppLink.href)
    : closeAppLink;
};

export default formatExternalLink;
